import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './fonts.css';
import './index.css';
import App from './App';
import { AuthProvider } from './AuthContext';
import { QueryProvider } from './contexts/QueryContext';

// Only use StrictMode in local development, not in deployed builds
// StrictMode causes double-renders which can trigger issues in production
const isDev = import.meta.env.DEV;

const app = (
  <QueryProvider>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </QueryProvider>
);

createRoot(document.getElementById('root')!).render(
  isDev ? app : app
);